import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DefaultButtonWrapper = styled.div`
  display: flex;
`;

const HoverButtonWrapper = styled.div`
  display: none;
`;

const ButtonWrapper = styled.div`
  :hover {
    ${DefaultButtonWrapper} {
      display: none;
    }

    ${HoverButtonWrapper} {
      display: flex;
    }
  }
`;

class InformationButton extends React.PureComponent {

  static propTypes = {
    importance: PropTypes.string,  // Importance levels allowed (primary, secondary, subdued, etc.)
  }

  render() {
    const importance = this.props.importance || 'subdued';
    return (
      <ButtonWrapper>
        <DefaultButtonWrapper>
          <qds-icon name="information-circle" importance={importance}></qds-icon>
        </DefaultButtonWrapper>
        <HoverButtonWrapper>
          <qds-icon name="information-circle-solid" importance={importance}></qds-icon>
        </HoverButtonWrapper>
      </ButtonWrapper>
    );
  }
}

export default InformationButton;
